/**
 * Bridge exposed by the Electron preload script (architecture.md › Desktop). Absent in a normal
 * browser, so every caller needs a web fallback.
 */
export interface DesktopBridge {
  platform: "darwin" | "win32" | "linux";
  version: string;
  openExternal(url: string): Promise<void>;
  pickFolder(): Promise<string | null>;
}

declare global {
  interface Window {
    desktop?: DesktopBridge;
  }
}

export const desktop: DesktopBridge | undefined =
  typeof window !== "undefined" ? window.desktop : undefined;

export function openExternal(url: string): void {
  if (desktop) void desktop.openExternal(url);
  else window.open(url, "_blank", "noopener,noreferrer");
}

/** Opens a new email in the user's mail program from a `mailto:` link; nothing is sent. */
export function openMail(href: string): void {
  if (desktop) void desktop.openExternal(href);
  else window.location.href = href;
}
